// frontend/src/services/managedLogin.service.ts
import api from './api';
import {
  ManagedLogin,
  ManagedLoginCreate,
  ManagedLoginUpdate,
} from '../types/managedLogin';

class ManagedLoginService {
  private baseUrl = '/managed-logins';

  /**
   * Get all managed logins
   */
  async getAll(): Promise<ManagedLogin[]> {
    const response = await api.get<ManagedLogin[]>(this.baseUrl);
    return response.data;
  }

  /**
   * Get a specific managed login
   */
  async getById(id: number): Promise<ManagedLogin> {
    const response = await api.get<ManagedLogin>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  /**
   * Create a new managed login
   */
  async create(data: ManagedLoginCreate): Promise<ManagedLogin> {
    const response = await api.post<ManagedLogin>(this.baseUrl, data);
    return response.data;
  }

  /**
   * Update a managed login
   */
  async update(id: number, data: ManagedLoginUpdate): Promise<ManagedLogin> {
    const response = await api.put<ManagedLogin>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  /**
   * Unlock a managed login (clear lockout and reset failed attempts)
   */
  async unlock(id: number): Promise<ManagedLogin> {
    const response = await api.put<ManagedLogin>(`${this.baseUrl}/${id}/unlock`);
    return response.data;
  }

  /**
   * Reactivate a deactivated managed login and clear all lockout state
   */
  async reactivate(id: number): Promise<ManagedLogin> {
    const response = await api.put<ManagedLogin>(`${this.baseUrl}/${id}/reactivate`);
    return response.data;
  }

  /**
   * Delete a managed login
   */
  async delete(id: number): Promise<void> {
    await api.delete(`${this.baseUrl}/${id}`);
  }

  /**
   * Manually run the rotation/retention sweep (admin testing).
   */
  async runMaintenance(): Promise<{ deactivated: number; warned: number; deleted: number }> {
    const response = await api.post<{ deactivated: number; warned: number; deleted: number }>(
      `${this.baseUrl}/run-maintenance`,
    );
    return response.data;
  }
}

const managedLoginService = new ManagedLoginService();
export default managedLoginService;
